import React, { createContext, useContext, useEffect, useState } from "react";
import { setApiToken, setLogoutFunktion } from "./api/apicall";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(() => localStorage.getItem("token"));

    // Always sync token with API helper when it changes
    useEffect(() => {
        setApiToken(token);
    }, [token]);

    const login = (newToken) => {
        setToken(newToken);
        localStorage.setItem("token", newToken);
    };

    const logout = () => {
        setToken(null);
        localStorage.removeItem("token");
    };

    setLogoutFunktion(logout)

    return (
        <AuthContext.Provider value={{ token, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
